import { Provider } from 'react-redux'
import React, { useEffect } from 'react'
import { CssBaseline } from '@mui/material'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider, Theme, StyledEngineProvider, createTheme } from '@mui/material/styles'
import './App.css'
import { configureStore } from './store'
import { RouterContainer } from './components/RouterContainer'
import { PersistGate } from 'redux-persist/integration/react'
import { Main } from './Main'
const { store, persistor } = configureStore()

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

function App({ credentials }): JSX.Element {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={createTheme()}>
        <CssBaseline />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Main credentials={credentials} />
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
